import { render, staticRenderFns } from "./SortTypes.vue?vue&type=template&id=44273036&"
import script from "./SortTypes.vue?vue&type=script&lang=js&"
export * from "./SortTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports